import Loader from '@/assets/icons/loading.svg?react';

export default function PageLoader() {
  return (
    <div className="flex h-dvh w-full items-center justify-center">
      <Loader className="inset-0 h-8 w-8" />
    </div>
  );
}
